import { Headers } from '@egw/components'
import { AllocationHoldingsDetails } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsAllocationHoldingsDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <AllocationHoldingsDetails />
    </Layout>
  )
}
